import axios from "axios";

let baseUrl = 'https://prod.v2.api.oatas.co/api'
let host = window.location.host
if (
  host === 'localhost:8080' ||
  host === 'localhost:8081' ||
  host === 'localhost:8082'
) {
  baseUrl = 'http://localhost:10050/api'
} else if (host.substring(0, 4) === 'dev.') {
  baseUrl = 'https://dev.v2.api.oatas.co/api'
} else if (host === '10.0.0.141:8080') {
  baseUrl = 'http://10.0.0.141:10050/api'
}

let apiV2 = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

// Add a response interceptor
apiV2.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default apiV2;
